<!--
 * @Author: xing.huang
 * @Date: 2021-02-08 09:40:55
 * @LastEditTime: 2021-02-08 14:47:47
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\report\CustomReport\ViewCustomReport.vue
 * @
-->
<template>
    <div style="width: 100%; heigh: 100%;">
        <el-row >
            <h3 style="text-align: center;">{{name}}</h3>
        </el-row>
        <div class="table_searchbar">
            <el-row class="search-input-row">
                <el-col :span="8" >
                    <span class="title">日期查询：</span>
                    <el-date-picker style="max-width:214px" v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                </el-col>
                <el-col :span="16" >
                    <div style="text-align:right">
                        <el-button type="primary" icon="el-icon-search" size="mini" @click="search">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-table :data="dataList" stripe style="width: 100%" class="CustomReportTable" :maxHeight='694'>
            <el-table-column   :label="item" v-for="(item,index) in columnNameList" :key='index' :prop="''+index"></el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    name: "ViewCustomReport",
    data(){
        return {
            W: false,
            columnNameList:[],
            id:null,
            name:'',
            dataList:[],
            dateRange: [],
            permission: JSON.parse(localStorage.getItem("permission")),
            
        };
    },
    mounted: function () {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? (this.W = true) : (this.W = false);
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? (this.W = true) : (this.W = false);
        };
    },
    activated(){
        this.initTable();
    },
    computed: {
        span() {
            return this.W ? 5 : 7;
        }
    },
    methods: {
        search: async function () {
            let dateRange = this.dateRange;
            if (!dateRange||dateRange.length==0) {
                this.$message.warning("请选择完整的时间区间");
                return;
            }

            let [beginDate,endDate] = dateRange
            let {data,msg,code,message} = await this.$RequestUtil.getAsync({url: '/api/customTable/getReportData',type:'sync',params: {id:this.id,beginDate,endDate},})
            if(code==0){
                let {columnNameList,dataList} = data
                dataList.forEach(item => {
                    item = item.map((sub,index)=>{
                        let key = index+''
                    return {key:sub}
                    })
                })
                this.columnNameList = columnNameList
                this.dataList = dataList
                
            }else{
                this.$message.error(msg||message)
            }
        },
        initTable: function () {
            this.id = this.$route.query.id
            this.name = this.$route.query.reportDataName
            let end = new Date().getTime()
            let endDate = commonUtils.timestampToDate(end,true)
            let beginDate = commonUtils.timestampToDate(end-7*24*60*60*1000,true)
            this.dateRange = [beginDate,endDate]
            this.search();
        },
        
        btnSearch: function () {
            this.search();
        },

        clearSearch() {
            this.dateRange = [];
        },
    },
    watch: {
        // 利用watch方法检测路由变化：
        $route: function(to, from) {
            // log(to,from,'触发')
            if(to.path==from.path){
                this.initTable()
            }
        }
    },
};
</script>
<style scoped>

.table_searchbar {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
}
.table_searchbar .title11 {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}

.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}

</style>



// WEBPACK FOOTER //
// src/views/report/CustomReport/ViewCustomReport.vue